import { render, staticRenderFns } from "./fmRailwayBoxTube.vue?vue&type=template&id=59941022&"
import script from "./fmRailwayBoxTube.vue?vue&type=script&lang=js&"
export * from "./fmRailwayBoxTube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59941022')) {
      api.createRecord('59941022', component.options)
    } else {
      api.reload('59941022', component.options)
    }
    module.hot.accept("./fmRailwayBoxTube.vue?vue&type=template&id=59941022&", function () {
      api.rerender('59941022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/RailwayExport/fmRailwayBoxTube.vue"
export default component.exports